import { put, debounce, select } from 'redux-saga/effects';
import * as filtersActions from '../actions/filters';
import * as documentsActions from '../actions/documents';

function* updateFilterFieldsSaga() {
  const filters = yield select(state => state.Documents.filters);
  let countFilters = 0;
  if (filters.search && filters.search.length > 1) {
    countFilters++;
  }
  if (filters.fields) {
    countFilters += Object.keys(filters.fields).length;
  }
  if (filters.count !== countFilters) {
    yield put(filtersActions.countFiltersOrdersForDocuments(countFilters));
  }
  if (countFilters > 0) {
    yield put(documentsActions.getFilterOrdersForDocuments(filters));
  } else {
    yield put(documentsActions.getAllOrdersForDocuments());
  }
}

export function* filtersConfigWatcher() {
  yield debounce(
    600,
    [
      filtersActions.updateFilterFieldsOrdersForDocuments.toString(),
      filtersActions.searchOrdersForDocuments.toString(),
    ],
    updateFilterFieldsSaga
  );
}
